import { productsFromStore } from './products-from-store.js';

export function createCheckoutPaymentSelect(selectedPaymentMethod, storeItems) {
    return productsFromStore(storeItems)
        .then((products) => ({
            'ecommerce': {
                'checkout': {
                    'actionField': { 'step': 3, 'option': selectedPaymentMethod },
                    'products': products,
                },
            },
            'event': 'gtm-ee-event',
            'gtm-ee-event-category': 'Enhanced Ecommerce',
            'gtm-ee-event-action': 'Checkout Step 3',
            'gtm-ee-event-non-interaction': 'False',
        }));
}
